<template>
  <div class="org-card-slim" v-if="payload" :data-id="payload['org-main-id']">
    <a :href="computedLink">
      <!-- left -->
      <div class="org-card-slim__left">
        <div v-if="payload['logo']" class="org-card-slim__img-container">
          <img class="org-card-slim__img" :src="payload['logo']" :alt="payload['org-name']">
        </div>
      </div>

      <!-- right -->
      <div class="org-card-slim__right">

        <div class="org-card-slim_body">
          <div class="org-card-slim__content">
            <!-- title -->
            <h3 v-if="payload['org-name']" class="org-card-slim__title">{{ payload['org-name'] }}</h3>
            <!-- description -->
            <p v-if="payload['summary']" class="org-card-slim__summary" v-html="payload['summary']"></p>
          </div>
          <div class="org-card-slim__actions">
            <block-action-follow-org :org_main_id="payload['org-main-id']"></block-action-follow-org>
          </div>
        </div>

        <div class="org-card-slim__footer">
          <!-- icons -->
          <div class="org-card-slim__icons">
            <div class="org-card-slim__icon-container">
              <img src="/images/icons/shared/lady.svg" class="org-card-slim__icon" alt="" title="Lady"/>
            </div>

            <div class="org-card-slim__icon-container">
              <img src="/images/icons/shared/artboard.svg" class="org-card-slim__icon" alt="" title="Art Board"/>
            </div>

            <div class="org-card-slim__icon-container">
              <img src="/images/icons/shared/church.svg" class="org-card-slim__icon" alt="" title="Church"/>
            </div>

            <div class="org-card-slim__icon-container">
              <img src="/images/icons/shared/top100.svg" class="org-card-slim__icon" alt="Escape Top 100" title="Escape Top 100"/>
            </div>
          </div>
          <!-- roles -->
          <a :href="searchLink" v-if="hasListings" class="org-card-slim__btn--roles">
            <img src="/images/icons/organisation/briefcase.svg" class="org-card-slim__icons-item-icon" alt="Briefcase" />
            Hiring
          </a>
        </div>

      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    payload: {
      type: [Object],
      default: {}
    }
  },

  data() {
    return {
			visible: false
    }
  },

	mounted() {
		//console.log('OrgCardSlim: ', this.payload);
	},

	methods:{
		intersection_handler(entries, observer, isIntersecting, ratio) {
			if (isIntersecting) {
				this.visible = true;
			}
		}
	},
  computed: {
    hasListings() {
			return (this.payload['listings-live-on-esc'] > 0 || this.payload['listings-live-on-other'] > 0)
		},
		searchLink() {
			var query_array = ["org-name="+this.payload['org-name']];
			var query = query_array.join("&");
			// Needs to be double encoded, don't know why!
			return '/search/jobs?q='+encodeURIComponent(encodeURIComponent(query));
		},
		computedLink() {
			if ('slug' in this.payload) {
				return `/organisation/${this.payload['slug']}`;
			}
			return '#';
		}
  }
}
</script>
